const getters = {
    RULES: ({ rules }) => rules,
    RULE: ({ rule }) => rule,
    FETCH_RULES_LOADING: ({ fetchRulesLoading }) => fetchRulesLoading,
    FETCH_RULE_LOADING: ({ fetchRuleLoading }) => fetchRuleLoading,
    CREATE_RULE_LOADING: ({ createRuleLoading }) => createRuleLoading,
    UPDATE_RULE_LOADING: ({ updateRuleLoading }) => updateRuleLoading,
    DELETE_RULE_LOADING: ({ deleteRuleLoading }) => deleteRuleLoading,
}

export default getters;